module.exports = __webpack_public_path__ + "static/media/vanskeleg.94136e59.m4a";